import { Client } from "@/Contracts";

export enum Modules {
	ALIGN = "align",
	OPPORTUNITY = "opportunity",
	DOCUMENT = "document",
	INTEGRATION = "integration"
}

export enum Stages {
	//opportunity module
	OPPORTUNITY_INTRODUCTION = "opportunity_introduction",
	ADD_OPPORTUNITY = "add_opportunity",
	OPPORTUNITY_ACTIVITIES = "activities",
	//document module
	DOCUMENT_INTRODUCTION = "document_introduction",
	ADD_DOCUMENT = "add_document",
	SELECTING_TEMPLATE = "selecting_template",
	EXPLORE_EDITOR = "explore_editor",
	//Align module
	ALIGN_INTRODUCTION = "align_introduction",
	ALIGN_VENDORS_AND_RESOURCES = "vendors_and_resources",
	ALIGN_EXPLORE_RESOURCES = "explore_resources",
	//Integration module
	INTEGRATION_SELECT_APP = "select_app",
	INTEGRATION_INTRODUCTION = "integration_introduction",
	INTEGRATION_APPS = "integrating_apps"
}

export const ModuleStageMap: Record<Modules, Stages[]> = {
	[Modules.ALIGN]: [
		Stages.ALIGN_INTRODUCTION,
		Stages.ALIGN_VENDORS_AND_RESOURCES,
		Stages.ALIGN_EXPLORE_RESOURCES
	],
	[Modules.OPPORTUNITY]: [
		Stages.OPPORTUNITY_INTRODUCTION,
		Stages.ADD_OPPORTUNITY,
		Stages.OPPORTUNITY_ACTIVITIES
	],
	[Modules.DOCUMENT]: [
		Stages.DOCUMENT_INTRODUCTION,
		Stages.ADD_DOCUMENT,
		Stages.SELECTING_TEMPLATE,
		Stages.EXPLORE_EDITOR
	],
	[Modules.INTEGRATION]: [
		Stages.INTEGRATION_SELECT_APP,
		Stages.INTEGRATION_INTRODUCTION,
		Stages.INTEGRATION_APPS
	]
};

export enum Steps {
	WELCOME_VIDEO = "welcome_video",
	/* document module */
	//INTRODUCTION
	HIGHLIGHT_DOCUMENT_MENUITEM = "highlight_document_menuitem",
	SHOW_DOCUMENT_INTRO_VIDEO = "show_document_intro_video",
	//ADD_DOCUMENT
	HIGHLIGHT_ADD_DOCUMENT_BUTTON = "highlight_add_document_button",
	SHOW_SELECT_TEMPLATE = "show_select_template",
	//SELECTING_TEMPLATE
	HIGHLIGHT_SELECT_TEMPLATE = "highlight_select_template",
	SHOW_CREATE_DOCUMENT = "show_create_document",
	//EXPLORE_EDITOR
	SHOW_DRAG_DROP_BLOCK = "show_drag_drop_block",
	SHOW_BLOCK_SAVE_BLOCK = "show_block_save_block",
	SHOW_SEND_DOCUMENT_IN_EDITOR = "show_send_document",
	SHOW_SEND_EMAIL = "show_send_email",
	SHOW_GO_BACK_TO_DOCUMENT_LIST = "show_go_back_to_document_list",
	HIGHLIGHT_CREATED_DOCUMENT_IN_LIST = "highlight_created_document_in_list",

	/* opportunity module */
	//INTRODUCTION
	HIGHLIGHT_OPPORTUNITY_MENUITEM = "highlight_opportunity_menuitem",
	SHOW_OPPORTUNITY_INTRO_VIDEO = "show_opportunity_intro_video",
	//ADD OPPORTUNITY
	HIGHLIGHT_ADD_OPPORTUNITY_BUTTON = "highlight_add_opportunity_button",
	HIGHLIGHT_ADD_OPPORTUNITY_DRAWER = "highlight_add_opportunity_drawer",
	HIGHLIGHT_OPPORTUNITY_SHARE_WITH_VENDOR_CHECKBOX = "highlight_opportunity_share_with_vendor_checkbox",
	HIGHLIGHT_OPPORTUNITY_SAVE_BUTTON = "highlight_opportunity_save_button",
	//OPPROTUNITY ACTIVITIES
	SHOW_OPPORTUNITY_CONGRATULATION_MODAL = "show_opportunity_congratulation_modal",
	/* align module */
	//INTRODUCTION
	HIGHLIGHT_ALIGN_MENUITEM = "highlight_align_menuitem",
	HIGHLIGHT_ALIGN_RESOURCES_BUTTON = "highlight_align_resources_button",
	HIGHLIGHT_ALIGN_VENDOR_RESOURCE_FOLDER = "highlight_align_vendor_resource_folder",
	HIGHLIGHT_ALIGN_VENDOR_RESOURCE_FILE = "highlight_align_vendor_resource_file",
	SHOW_ALIGN_CONGRATULATION_MODAL = "show_align_congratulation_modal"
}

export enum WelcomeVideoStatus {
	UNOPENED = "unopened",
	OPENED = "opened",
	SKIPPED = "skipped",
	WATCHED = "watched",
	DONT_SHOW_AGAIN = "dont_show_again"
}

export interface WelcomeVideo {
	readonly status: WelcomeVideoStatus;
}

export enum SignupStatusValues {
	LINK_UNOPENED = "link_unopened",
	LINK_OPENED = "link_opened",
	COMPLETED = "complete"
}

export interface SignupStatus {
	readonly status: SignupStatusValues;
	readonly signup_link?: string | null;
}

export interface ModuleStage {
	name: string;
	is_complete: boolean;
}
export interface CheckListModule {
	name: string;
	is_complete: boolean;
	created_entity_id: string | null;
	created_entity_type: string | null;
	stages: ModuleStage[];
}
export interface CheckListBarData {
	readonly id: string;
	readonly company_id: string;
	readonly user_id: string;
	readonly deleted: boolean;
	readonly created: string;
	readonly updated: string;
	active_module: number | null;
	readonly is_checklist_active: boolean;
	readonly is_checklist_complete: boolean;
	readonly welcome_video: WelcomeVideo;
	readonly signup: SignupStatus;
	readonly modules: CheckListModule[];
}

export const GuideIntroductionSteps = [
	Steps.HIGHLIGHT_DOCUMENT_MENUITEM,
	Steps.HIGHLIGHT_OPPORTUNITY_MENUITEM,
	Steps.HIGHLIGHT_ALIGN_MENUITEM
];
export interface UpdateCheckListBarDataPayload {
	active_module?: number | null;
	is_checklist_active?: boolean;
	is_checklist_complete?: boolean;
	welcome_video?: WelcomeVideo;
	signup?: SignupStatus;
	modules?: CheckListModule[];
}
export interface UpdateCheckListBarDataRequest {
	requestPayload: UpdateCheckListBarDataPayload;
	hasAPIUpdate: boolean;
}
export interface ClientCount {
	all: number;
}
export interface ClientsResponse {
	filtered_count_map: ClientCount;
	data: Client[];
}
